export default {
    baseStyle: {
        title: {
            textStyle: 'webH2',
            mt: {base: 12, lg: 0},
            mb: {base: 12, lg: 16}
        },
        billingSectionStack: {
            spacing: 6,
            mt: {base: 12, lg: 16}
        },
        billingAddressHeading: {
            as: 'h3',
            textStyle: 'webH4'
        },
        billingRadioStack: {
            spacing: 3
        },
        addNewBillingLink: {
            textStyle: 'labelXs',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            mb: 6
        },
        addNewBillingIcon: {
            w: '20px',
            h: '20px'
        },
        addressBookCta: {
            display: 'block',
            textStyle: 'bodyXsSLink',
            minH: 'auto',
            h: 'auto',
            ml: 'auto'
        },
        billingAddressBox: {
            mt: {base: 12, lg: 16}
        }
    }
}
